import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import Tooltip from '@mui/material/Tooltip';
import SecurityIcon from '@mui/icons-material/Security';
import { CollapseCard, Typography } from '@totalsoft/rocket-ui';

export const UserGroupsComponent = ({ userGroups, t, toggleExpanded, expanded }) => {
  return (
    <CollapseCard
      icon={GroupIcon}
      title={t('User.UserProfile.UserGroups.Title')}
      expanded={expanded}
      onToggle={toggleExpanded}
      toggleOnHeaderClick
    >
      <Grid container>
        {userGroups.map((group, index) => (
          <Grid item xs={4} key={index} display='flex' gap={1} alignItems='center'>
            <Typography fontWeight={'bold'}>{group.userGroupName}</Typography>
            {group.isAdmin && (
              <Tooltip title={t('User.UserProfile.UserGroups.IsAdmin')}>
                <SecurityIcon />
              </Tooltip>
            )}
          </Grid>
        ))}
      </Grid>
    </CollapseCard>
  );
};

UserGroupsComponent.propTypes = {
  userGroups: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired
};

export default compose(withTranslation())(UserGroupsComponent);
